import ScopeFormCst from "../ScopeFormCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import ModalCst, { OutcomesInterface } from "@components/ModalCst";
import { fetcher } from "src/services/config";
import { useFetchDetail } from "@hooks/useFetchDetail";
import { Box, Container } from "@mui/material";
import { ServicesURL, getAllErrorsAsString } from "@utils/utilsApi";
import { PagesID } from "@utils/utilsConfigurations";
import { useState } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { MethodType } from "src/services/type";
import useSWRMutation from "swr/mutation";
import ButtonBackPage from "@components/ButtonBackPage";

const EditScope: React.FC = () => {
  const { t } = useTranslation(["scopes-page"]);
  const { idScope, id } = useParams();
  const navigate = useNavigate();

  const { columns, dataDetail, mutate } = useFetchDetail(
    `${ServicesURL.getScopes}`,
    idScope,
    PagesID["scopes"],
  );

  // CUSTOM API FOR APPLICATION/JSON-PATCH+JSON
  const { trigger: triggerScope } = useSWRMutation(
    `${ServicesURL.postScopes}/${idScope}`,
    (url: string, arg: { arg: any }) =>
      fetcher<any>(`${url}`, MethodType.PUT, { ...arg.arg }),
  );

  const getInitialOutcome = () => {
    return {
      budget: {
        code: undefined,
        message: t("edit.outcome.scopes.messageLoading"),
        title: t("edit.outcome.scopes.title"),
      },
    };
  };

  const initialOutcome: OutcomesInterface = {
    budget: {
      code: undefined,
      message: t("edit.outcome.scopes.messageLoading"),
      title: t("edit.outcome.scopes.title"),
    },
  };

  const [outcome, setOutcome] = useState<OutcomesInterface>(initialOutcome);
  const [openOutcome, setOpenOutcome] = useState(false);

  const onSubmit = async (inputForm: any) => {
    setOpenOutcome(true);
    const initialOutcomeState: any = getInitialOutcome();
    setOutcome(initialOutcomeState);
    const newOutcome: any = JSON.parse(JSON.stringify(initialOutcomeState));

    const objToSend: any = {
      title: inputForm.title || null,
      sub_scopes: inputForm.sub_scopes || null,
    };

    try {
      await triggerScope(objToSend);
      newOutcome.budget.code = "OK";
      newOutcome.budget.message = t("edit.outcome.scopes.messageOK");
      setOutcome(newOutcome);
    } catch (error) {
      newOutcome.budget.code = "KO";
      newOutcome.budget.message = getAllErrorsAsString(error);
      setOutcome(newOutcome);
    }
    mutate(inputForm);
  };

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-scopes.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <ScopeFormCst
              row={dataDetail?.dto || []}
              columns={columns}
              onSubmit={onSubmit}
              fullWidth={true}
            />
          </Box>
        )}
      </Container>
      <ModalCst
        open={openOutcome}
        setOpen={setOpenOutcome}
        typeOfModal={"outcome"}
        data={{
          outcome: outcome,
          callBackSubmit: () => {
            setOpenOutcome(!openOutcome);
            navigate(
              id
                ? `/corporate/${id}/detail/budget-management/setup/scopes`
                : `/budget-management/setup/scopes`,
            );
          },
        }}
      />
    </AnimationFadeIn>
  );
};

export default EditScope;
